@let obs =
  {
    suggestions: suggestions$ | async,
    suggestIsLoading: suggestIsLoading$ | async,
    isDesktop: isDesktop$ | async,
  };

<div class="address-suggestions-select" [class.active]="formControl.value" [class.has-back-arrow]="showBackArrow">
  @if (showBackArrow) {
    <button
      class="address-suggestions-select-left-side btn-reset color-black btn-icon"
      aria-label="back"
      type="button"
      (click)="backArrowClick.emit()"
    >
      <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.ARROW_PREV"></sd-icon>
    </button>
  }

  <ng-select
    #addressSuggestionsSelect
    class="address-suggestions-select-select text-h6-s text-xl-h6-m"
    [class.suppress-dropdown]="suppressEmptyDropdown && !formControl.value"
    [items]="obs.suggestions"
    [formControl]="formControl"
    [placeholder]="placeholder"
    [typeahead]="selectTypeahead"
    [editableSearchTerm]="true"
    [clearable]="false"
    bindLabel="value"
    bindValue="value"
    loadingText="Идет поиск..."
    [notFoundText]="obs.isDesktop ? 'Ничего не найдено' : 'по вашему запросу ничего не найдено'"
    typeToSearchText="введите адрес"
    dropdownPosition="bottom"
    (input)="onInputSelect($event)"
    (focus)="onFocusSelect($event)"
    (change)="onChangeSelect($event)"
    (blur)="onBlurSelect($event)"
    (open)="onOpened()"
    (close)="onClosed()"
  ></ng-select>

  @if (obs.suggestIsLoading && formControl.value) {
    <sd-loader class="address-suggestions-select-right-side" theme="orange" size="m"></sd-loader>
  } @else if (formControl.value) {
    <button
      class="address-suggestions-select-right-side btn-reset color-black-warm-400 btn-icon"
      aria-label="reset"
      tabindex="0"
      type="button"
      (click)="clear()"
    >
      <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.CROSS"></sd-icon>
    </button>
  } @else {
    <button
      class="address-suggestions-select-right-side btn-search color-black-warm-400 btn-icon"
      aria-label="search"
      tabindex="0"
      type="submit"
      (click)="addressSuggestionsSelect.focus()"
    >
      <sd-icon class="icon-size-s icon-size-md-m" [type]="iconTypes.SEARCH"></sd-icon>
    </button>
  }
</div>
